"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const Loader_1 = __importDefault(require("../../Loader"));
const constants_1 = require("./constants");
const TransakWidget = ({ env, crypto, amount }) => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [frameSrc, setFrameSrc] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        setLoading(true);
        const baseUrl = env === "development" ? constants_1.BASE_STAGE : constants_1.BASE_PROD;
        const apiKey = env === "development" ? constants_1.KEY_STAGE : constants_1.KEY_PROD;
        const environment = env === "development" ? "STAGING" : "PRODUCTION";
        const query = new URLSearchParams();
        query.append("apiKey", apiKey);
        query.append("environment", environment);
        if (crypto)
            query.append("cryptoCurrencyCode", crypto);
        if (amount)
            query.append("defaultFiatAmount", amount.toString());
        const src = `${baseUrl}?${query.toString()}`;
        setFrameSrc(src);
        setLoading(false);
    }, [crypto, env, amount]);
    if (loading)
        return (react_1.default.createElement(styled_1.LoaderContainer, null,
            react_1.default.createElement(Loader_1.default, null)));
    return (react_1.default.createElement("iframe", { height: "625", title: "Transak On/Off Ramp Widget", src: frameSrc, style: {
            display: "block",
            width: "100%",
            maxHeight: 625,
            maxWidth: 500,
            boxSizing: "border-box",
            border: 0,
        } }));
};
exports.default = TransakWidget;
//# sourceMappingURL=TransakWidget.js.map